import 'proto-polyfill'
import matchAll from 'string.prototype.matchall'
import replaceAll from 'string.prototype.replaceall'

matchAll.shim()
replaceAll.shim()
